import React, { useState, useEffect, useContext } from 'react'
import AdminContext from '../../../StateContext/Application'
import { apiurl } from '../../../../../path'
const ContractorList = () => {
    const context = useContext(AdminContext)
    const { GetAllContractorList } = context
    const [contractor, setContractorList] = useState([])
    const [filteredBills, setFilteredBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState('');

    const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

    const getContractorList = async () => {
        let data = await GetAllContractorList()
        console.log("data",data);
        
        setContractorList(data)
        setFilteredBills(data);
    }
    useEffect(() => {
        getContractorList()
    }, [])
    let contractorList = []
    if (contractor.length > 0) {
        contractorList = contractor
    }
    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = contractor.filter(bill =>
            Object.values(bill).some((val) =>
                (val || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1); // Reset to page 1 on search
    }, [searchTerm, contractor]);
    return (
        <div style={{ overflowX: "hidden", display: 'grid', justifyContent: 'center', padding: "20px 0px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "80vw", maxWidth: "1200px", marginBottom: "15px" }}>
                <h4 style={{ margin: "10px" }}>Vendor List</h4>
                <input type="text" placeholder="Search" onChange={(e) => setSearchTerm(e.target.value)} value={searchTerm} style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }} />
            </div>
            <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%", }}>
                <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
                    <table style={{ width: '100%', width: "100%", borderCollapse: "collapse", minWidth: "1200px", }}>
                        <thead style={{ borderTop: 'none' }}>
                            <tr style={{ color: 'white', border: 'none', overflow: 'hidden', height: '3.5rem' }}>
                            <th style={{ padding: '8px' }}>Vendor ID</th>
                                <th style={{ padding: '8px' }}>Company Name</th>
                                <th style={{ padding: '8px' }}>Address</th>
                                <th style={{ padding: '8px' }}>Mobile No</th>
                                <th style={{ padding: '8px' }}>Email</th>
                                <th style={{ padding: '8px' }}>Pincode</th>
                                <th style={{ padding: '8px' }}>City</th>
                                <th style={{ padding: '8px' }}>Pan NUMBER</th>
                                <th style={{ padding: '8px' }}>Tan NUMBER</th>
                                <th style={{ padding: '8px' }}>GST Number</th>
                                <th style={{ padding: '8px' }}>Aadhaar Number</th>
                                <th style={{ padding: '8px' }}>IFSC Code</th>
                                <th style={{ padding: '8px' }}>MICR Code</th>
                                <th style={{ padding: '8px' }}>Bank Name</th>
                                <th style={{ padding: '8px' }}>Branch Name</th>
                                <th style={{ padding: '8px' }}>Account Number</th>
                                <th style={{ padding: '8px' }}>Paasbook Doc</th>
                                <th style={{ padding: '8px' }}>Cheque Doc</th>
                                <th style={{ padding: '8px' }}>Pan Doc</th>
                                <th style={{ padding: '8px' }}>Tan Doc</th>
                                <th style={{ padding: '8px' }}>GST Doc</th>
                                <th style={{ padding: '8px' }}>Aadhaar Doc</th>
                                <th style={{ padding: '8px' }}>Creation Date</th>
                            </tr>
                        </thead>
                        {
                            currentBills?.map((contractor, index) => {
                                const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                                return (
                                    <tbody>
                                        <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor, }}>
                                            <td style={{ padding: '8px' }}>{contractor.UniqueID}</td>
                                            <td style={{ padding: '8px' }}>{contractor.Bidder_CompanyName}</td>
                                            <td style={{ padding: '8px' }}>{contractor.Address}</td>
                                            <td style={{ padding: '8px' }}>{contractor.Mobile_No}</td>
                                            <td style={{ padding: '8px' }}>{contractor.Email}</td>
                                            <td style={{ padding: '8px' }}>{contractor.PinCode}</td>
                                            <td style={{ padding: '8px' }}>{contractor.City}</td>
                                            <td style={{ padding: '8px' }}>{contractor.PAN_No}</td>
                                            <td style={{ padding: '8px' }}>{contractor.TAN_No}</td>
                                            <td style={{ padding: '8px' }}>{contractor.GST_No}</td>
                                            <td style={{ padding: '8px' }}>{contractor.AadhaarNo}</td>
                                            <td style={{ padding: '8px' }}>{contractor.IFSC_CODE}</td>
                                            <td style={{ padding: '8px' }}>{contractor.MICR_No}</td>
                                            <td style={{ padding: '8px' }}>{contractor.BANK_NAME}</td>
                                            <td style={{ padding: '8px' }}>{contractor.BranchName}</td>
                                            <td style={{ padding: '8px' }}>{contractor.Account_Number}</td>
                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.PaasbookDoc}`} target='_blank'>{contractor.PaasbookDoc}</a></td>
                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.ChequeDoc}`} target='_blank'>{contractor.ChequeDoc}</a></td>
                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.PanDoc}`} target='_blank'>{contractor.PanDoc}</a></td>
                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.TanDoc}`} target='_blank'>{contractor.TanDoc}</a></td>
                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.GstDoc}`} target='_blank'>{contractor.GstDoc}</a></td>
                                            <td style={{ padding: '8px' }}><a href={`${apiurl}/ContractorDocsImages/${contractor.AadharDoc}`} target='_blank'>{contractor.AadharDoc}</a></td>
                                            <td style={{ padding: '8px' }}>{contractor.Date?.split('T')[0].replace(' ')}</td>
                                        </tr>
                                    </tbody>
                                )
                            })
                        }
                    </table>
                </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: ' 0px 10px 0px 10px', height: '3rem', alignItems: 'center' }}>
                <div>
                    <p style={{ margin: '0px', color: 'black' }}>Showing {filteredBills?.length} of {contractor?.length} entries</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* First Page Button */}
                    <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0 }}>
                        &laquo;
                    </button>
                    {/* Previous Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &lt;
                    </button>

                    <button
                        style={{background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', margin: 0, borderRadius: 0, border: '1px solid lightgrey', borderLeft: "none" }}>{currentPage}
                    </button>
                    {/* Next Button */}
                    <button
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &gt;
                    </button>
                    {/* Last Page Button */}
                    <button
                        onClick={() => setCurrentPage(totalPages)}
                        disabled={currentPage === totalPages}
                        style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', margin: 0, borderRadius: 0, borderLeft: "none" }}>
                        &raquo;
                    </button>
                </div>

            </div>
        </div>
    )
}

export default ContractorList
